/**
 * ChatAvatar Component
 * Avatar con stato online integrato
 */

import { OnlineStatus } from '../shared/OnlineStatus';

interface ChatAvatarProps {
  name: string;
  imageUrl?: string;
  isGroup?: boolean;
  isOnline?: boolean;
  isTyping?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-12 h-12 text-sm',
  lg: 'w-12 h-12 text-base',
};

const statusPosition = {
  sm: '-bottom-0.5 -right-0.5',
  md: '-bottom-0.5 -right-0.5',
  lg: 'bottom-0 right-0',
};

export function ChatAvatar({
  name,
  imageUrl,
  isGroup = false,
  isOnline = false,
  isTyping = false,
  size = 'md',
  className = '',
}: ChatAvatarProps) {
  // Safe name with fallback
  const safeName = name || '?';
  const initials = safeName
    .split(' ')
    // Array.from: il primo carattere intero anche se e' un'emoji (n[0] ne prendeva meta').
    .map((n) => Array.from(n)[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase() || '?';

  const bgColor = isGroup
    ? 'bg-[#2383E2]/10 text-[#2383E2]'
    : 'bg-[#37352F]/10 text-[#37352F] dark:bg-white/10 dark:text-white';

  return (
    <div className={`relative flex-shrink-0 ${className}`}>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={safeName}
          className={`${sizeClasses[size]} rounded-full object-cover`}
        />
      ) : (
        <div
          className={`
            ${sizeClasses[size]} ${bgColor}
            rounded-full flex items-center justify-center font-medium
          `}
        >
          {initials}
        </div>
      )}
      {!isGroup && (isOnline || isTyping) && (
        <OnlineStatus
          isOnline={isOnline}
          isTyping={isTyping}
          size="sm"
          className={`absolute ${statusPosition[size]}`}
        />
      )}
    </div>
  );
}
